// MainPage.js
import React, { useState } from 'react';
import '../aviso_legal/aviso_legal.css'; // Add custom styles for the main content
import { useTranslation } from 'react-i18next';

const PoliticaPrivacidad = () => {
    const { t, i18n } = useTranslation('politica_privacidad');

    return (
        <main className="main-content">
            {/* Main Section */}
            <section className="dosier">
                <div className="dosier__image">
                    <img src={`${process.env.PUBLIC_URL}/images/Imagen-7-scaled.jpg`} alt="logo" />
                    <div className="dosier__image__text"><span>{t('politica_privacidad_tittle')}</span></div> 
                </div>
            </section>

            <section className="aviso_legal__info">
                <div className="aviso_legal__info__box">
                    <span><strong>{t('privacidad_tittle_1')}</strong><br></br>{t('privacidad_1')}<br></br><br></br></span>
                    <span><strong>{t('privacidad_tittle_2')}</strong><br></br>{t('privacidad_2')}<br></br><br></br></span>
                    <span><strong>{t('privacidad_tittle_3')}</strong><br></br>{t('privacidad_3')}<br></br><br></br></span>
                    <span><strong>{t('privacidad_tittle_4')}</strong><br></br>{t('privacidad_4')}<br></br><br></br></span>
                    <span><strong>{t('privacidad_tittle_5')}</strong><br></br>{t('privacidad_5')}<br></br><br></br></span>
                    <span><strong>{t('privacidad_tittle_6')}</strong><br></br>{t('privacidad_6')}<br></br><br></br></span>
                    <span><strong>{t('privacidad_tittle_7')}</strong><br></br>{t('privacidad_7')}<br></br><br></br></span>
                    <span><strong>{t('privacidad_tittle_8')}</strong><br></br>{t('privacidad_8')}<br></br><br></br></span>
                    <span><strong>{t('privacidad_tittle_9')}</strong><br></br>{t('privacidad_9')}<br></br><br></br></span>
                </div>
            </section>
        </main>
    );
};

export default PoliticaPrivacidad;
